var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "historyDialog" },
    [
      _c("div", { staticClass: "historyDialog-flex" }, [
        _c(
          "div",
          { staticClass: "historyDialog-header" },
          [
            _c(
              "div",
              { staticClass: "flex-main-container" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "confirm-btn-plain addDialogBtn",
                    attrs: { plain: "" },
                    on: { click: _vm.newDialog },
                  },
                  [_vm._v(_vm._s(_vm.$i18.language("新建对话")))]
                ),
                _vm.$util.judgeOrigin() == "DF"
                  ? _c(
                      "div",
                      {
                        staticClass: "video-teach-box",
                        on: { click: _vm.clickVideo },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "newIcon",
                          attrs: { name: "video-teach" },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$i18.language("视频教学"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            [
              _c("el-divider"),
              _c(
                "el-input",
                {
                  staticClass: "search",
                  attrs: {
                    size: "mini",
                    placeholder: _vm.$t("tableComponent.search"),
                    maxlength: 10,
                  },
                  on: { blur: _vm.changeSearch },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.changeSearch.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function ($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "suffix" },
                    on: { click: _vm.changeSearch },
                    slot: "suffix",
                  }),
                ]
              ),
            ],
          ],
          2
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "historyDialog-list",
            attrs: {
              "element-loading-text": _vm.$t("message.loading") + "...",
            },
          },
          [
            _c("RecycleScroller", {
              staticClass: "recycleScroller",
              attrs: {
                items: _vm.filteredHistoryList,
                "item-size": 40,
                "key-field": "id",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ item }) {
                    return [
                      _c(
                        "div",
                        {
                          class: [
                            _vm.actDialogId == item.id ? "actived" : "",
                            "content-title",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.changeActDialog(item)
                            },
                          },
                        },
                        [
                          _vm.editVisibleId == item.id
                            ? [
                                _c("el-input", {
                                  ref: "inputRef",
                                  on: {
                                    blur: function ($event) {
                                      return _vm.handleInputConfirm(item)
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.handleInputConfirm(item)
                                    },
                                  },
                                  model: {
                                    value: _vm.newTitleValue,
                                    callback: function ($$v) {
                                      _vm.newTitleValue = $$v
                                    },
                                    expression: "newTitleValue",
                                  },
                                }),
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "isSticktop" },
                                  [
                                    item.top
                                      ? _c("svg-icon", {
                                          attrs: { name: "sticktop" },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "title-text" }, [
                                  _c("span", { attrs: { title: item.title } }, [
                                    _vm._v(_vm._s(item.title)),
                                  ]),
                                ]),
                                _c("div", { staticClass: "op" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "op-item",
                                      class: item.top ? "isTop" : "",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.top(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: { name: "sticktop" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "op-item",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.edit(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: { name: "edittitle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "op-item",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.del(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: { name: "deldialog" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                        ],
                        2
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("help-video", {
        ref: "helpVideo",
        attrs: { currentVideo: _vm.currentVideo, saveTime: false },
        on: { clearVideo: _vm.clearVideo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }